import { Helmet } from "react-helmet-async";
import { Link, NavLink, Outlet, useLocation, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ArrowLeft } from "lucide-react";
import { selectIsAuthenticated } from "store/reducer";
import { cn } from "lib/utils";
import SettingsUserSummary from "pages/settings/SettingsUserSummary";

const NAV = [
  { to: "/settings/profile", label: "Profile" },
  { to: "/settings/image", label: "Change image" },
  { to: "/settings/password", label: "Change password" },
];

function navLinkClassName({ isActive }) {
  return cn(
    "block w-full border-b border-border py-3.5 text-left text-base font-medium transition-colors",
    isActive ? "text-accent" : "text-foreground hover:text-accent"
  );
}

export default function SettingsLayout() {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const location = useLocation();

  if (!isAuthenticated) {
    return (
      <Navigate to="/sign-in" state={{ from: location.pathname }} replace />
    );
  }

  return (
    <>
      <Helmet>
        <title>Settings | Fortify</title>
      </Helmet>
      <div className="bg-secondary/30 min-h-[70vh]" >
        <div className="container mx-auto max-w-6xl px-4 py-10 sm:px-6 lg:px-12 xl:px-16">
          <div className="mb-8 flex flex-wrap items-center justify-between gap-4">
            <Link
              to="/dashboard"
              className="inline-flex items-center gap-2 text-sm font-medium text-accent hover:underline"
            >
              <ArrowLeft className="h-4 w-4" />
              Back to dashboard
            </Link>
          </div>

          <div className="grid grid-cols-1 gap-10 lg:grid-cols-[minmax(0,220px)_1fr] lg:gap-12">
            <aside className="border-b border-border pb-6 lg:border-b-0 lg:border-r lg:pb-0 lg:pr-10">
              <nav aria-label="Settings sections">
                {NAV.map(({ to, label }) => (
                  <NavLink key={to} to={to} className={navLinkClassName} end={to === "/settings/profile"}>
                    {label}
                  </NavLink>
                ))}
              </nav>
            </aside>
            <div className="min-w-0 space-y-8">
              <SettingsUserSummary />
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
